import styled from "styled-components";

const Button = styled.button`
  border-radius: 4px;
  cursor: pointer;
  padding: 0 18px;
  height: 32px;
  min-height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg};
  &:hover {
    opacity: 0.8;
  }
`;

export default Button;
